import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'
import AutoTable from 'components/AutoTable'
import { Alert } from 'reactstrap'

class LicenseResultsGrid extends React.Component {
  static propTypes = {
    licenses: PropTypes.arrayOf(PropTypes.object),
  }

  static defaultProps = {
    licenses: [],
  }

  columns = [
    {
      title: 'NS Customer Id',
      fieldValue: 'site.netSuiteCustomer.nsCustomerId',
    },
    {
      title: 'School',
      fieldValue: row => {
        const { site, siteName } = row || {}
        const { id } = site || {}
        return <Link to={`/css-admin/sites/${id}`}>{siteName}</Link>
      },
    },
    {
      title: 'Product',
      fieldValue: row =>
        `[${row.product.skuCode}: ${row.product.sku.skuValue}] - ${row.product.description}`,
    },
    {
      title: 'Setup Admin',
      fieldValue: row => {
        const { setupAdminEmail, setupAdminId } = row || {}
        if (setupAdminEmail && setupAdminId) {
          return (
            <Link
              to={`/css-admin/users/${row.setupAdminEmail}/${setupAdminId}`}
            >
              {setupAdminEmail}
            </Link>
          )
        } else {
          return setupAdminEmail
        }
      },
      sortValue: 'setupAdminEmail',
      filterValue: 'setupAdminEmail',
    },
    {
      title: 'NS Subscription Id',
      fieldValue: row => {
        return (
          <Link to={`/css-admin/subscriptions/${row.subscriptionId}`}>
            {row.nsSubscriptionId}
          </Link>
        )
      },
      sortValue: 'nsSubscriptionId',
      filterValue: 'nsSubscriptionId',
    },
    {
      title: 'NS License Id',
      fieldValue: row => {
        return (
          <Link to={`/css-admin/licenses/${row.id}`}>{row.nsLicenseId}</Link>
        )
      },
      sortValue: 'nsLicenseId',
      filterValue: 'nsLicenseId',
    },
    {
      title: 'Expiration',
      fieldValue: row => {
        if (row.expirationDate) {
          return moment(row.expirationDate).format('YYYY-MM-DD')
        } else return ''
      },
    },
  ]

  render = () => {
    const { licenses } = this.props
    return licenses.length ? (
      <AutoTable
        borderless
        columns={this.columns}
        filter
        headThemeLight
        rows={licenses}
        sort
      />
    ) : (
      <Alert color="warning">No results found</Alert>
    )
  }
}

export default LicenseResultsGrid



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/search/LicenseResultsGrid.js